import { IObservable, Subject } from '~/rage/utils';
import {
	IPhoneNotification,
	IPhoneNotificationsCount,
	IPhoneSettings,
	PhoneApps,
} from '~/shared';
import { IPhoneService } from './phoneServiceTypes';

export class PhoneServiceStub implements IPhoneService {
	private activeApp = new Subject<PhoneApps | null>(null);
	private settings = new Subject<IPhoneSettings>({
		brightness: 1,
		wallpaperIndex: 0,
		notificationsEnabled: true,
		soundsEnabled: true,
	});
	private phoneNumber = new Subject<string>('88005553535');
	private notificationState = new Subject<IPhoneNotification | null>(null);
	private notificationsCount = new Subject<IPhoneNotificationsCount[]>([
		{
			app: PhoneApps.CONTACTS,
			count: 52,
		},
		{
			app: PhoneApps.MESSENGER,
			count: 1,
		},
	]);

	constructor() {
		(window as any).setPhoneActiveApp = (app: PhoneApps | null) => {
			this.activeApp.next(app);
		};
	}

	public getActiveApp(): IObservable<PhoneApps | null> {
		return this.activeApp;
	}

	public async openCamera(): Promise<void> {
		console.log('PhoneService: openCamera');
	}

	public async openGps(): Promise<void> {
		console.log('PhoneService: openGps');
	}

	public async closeGps(): Promise<void> {
		console.log('PhoneService: closeGps');
	}

	public async openAds(): Promise<void> {
		console.log('PhoneService: openAds');
	}

	public async closeAds(): Promise<void> {
		console.log('PhoneService: closeAds');
	}

	public getSettings(): IObservable<IPhoneSettings> {
		return this.settings;
	}

	public setBrightnessValue(brightness: number): void {
		const clampedValue = Math.min(Math.max(brightness, 0), 1);
		this.settings.next({
			...this.settings.getValue(),
			brightness: clampedValue,
		});
	}

	public async setActiveWallpaperIndex(index: number): Promise<void> {
		const clampedValue = Math.min(Math.max(index, 0), 5);
		this.settings.next({
			...this.settings.getValue(),
			wallpaperIndex: clampedValue,
		});
	}

	public getNotificationState(): IObservable<IPhoneNotification | null> {
		return this.notificationState;
	}

	public async setNotificationsEnabled(value: boolean): Promise<void> {
		this.settings.next({
			...this.settings.getValue(),
			notificationsEnabled: value,
		});
	}

	public async setSoundsEnabled(value: boolean): Promise<void> {
		this.settings.next({ ...this.settings.getValue(), soundsEnabled: value });
	}

	public getPhoneNumber(): IObservable<string> {
		return this.phoneNumber;
	}

	public getNotificationsCount(): IObservable<IPhoneNotificationsCount[]> {
		return this.notificationsCount;
	}

	public async exit(): Promise<void> {
		console.log('PhoneService: exit');
	}
}
